// New Worlds Level Configurations (201-400)
// This file contains level configurations for 10 new worlds

// Import membership world levels
import { MEMBER_WORLD_LEVELS } from './memberWorld';
import { VIP_WORLD_LEVELS } from './vipWorld';

// ===== VOLCANIC CORE (201-220) =====
// Theme: Deep inside a volcano with lava flow mechanics
// Unique Mechanic: Lava rises from bottom each turn
export const VOLCANIC_CORE_LEVELS = [
  // Levels 201-205: Introduction to Volcanic Core
  {
    id: 201,
    name: "Level 201",
    subtitle: "Into the Volcano",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "orange",
    targetEmoji: "🍊",
    targetCount: 45,
    moves: 28,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 8, // Lava rises every 8 moves
    obstacles: { type: "volcanic", magma_rock: 8, ash_cloud: 5 },
    bgColor: "from-red-900 via-orange-800 to-yellow-700",
    borderColor: "border-red-600",
  },
  {
    id: 202,
    name: "Level 202",
    subtitle: "Magma Chamber",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "apple",
    targetEmoji: "🍎",
    targetCount: 50,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 7,
    obstacles: { type: "volcanic", magma_rock: 10, fire_geyser: 4 },
    bgColor: "from-red-950 via-orange-900 to-red-800",
    borderColor: "border-orange-500",
  },
  {
    id: 203,
    name: "Level 203",
    subtitle: "Ash Fields",
    difficulty: "Hard",
    missionType: "reach_score",
    targetFruit: "banana",
    targetEmoji: "⭐",
    targetCount: 12000,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 8,
    obstacles: { type: "volcanic", ash_cloud: 15, magma_rock: 6 },
    bgColor: "from-gray-800 via-red-900 to-orange-800",
    borderColor: "border-gray-600",
  },
  {
    id: 204,
    name: "Level 204",
    subtitle: "Fire Geysers",
    difficulty: "Hard",
    missionType: "create_striped",
    targetFruit: "striped",
    targetEmoji: "🌈",
    targetCount: 8,
    moves: 28,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 7,
    obstacles: { type: "volcanic", fire_geyser: 8, lava_flow: 4 },
    bgColor: "from-orange-900 via-red-800 to-yellow-700",
    borderColor: "border-yellow-500",
  },
  {
    id: 205,
    name: "Level 205",
    subtitle: "Molten River",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "pear",
    targetEmoji: "🍐",
    targetCount: 55,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 6,
    obstacles: { type: "volcanic", lava_flow: 10, magma_rock: 8 },
    bgColor: "from-red-900 via-orange-700 to-yellow-600",
    borderColor: "border-red-500",
  },
  // Levels 206-210: Medium difficulty
  {
    id: 206,
    name: "Level 206",
    subtitle: "Obsidian Caves",
    difficulty: "Expert",
    missionType: "break_ice",
    targetFruit: "ice",
    targetEmoji: "🧊",
    targetCount: 25,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 6,
    obstacles: { type: "volcanic", magma_rock: 12, ash_cloud: 8, ice: 25 },
    bgColor: "from-gray-900 via-red-900 to-black",
    borderColor: "border-gray-700",
  },
  {
    id: 207,
    name: "Level 207",
    subtitle: "Eruption Zone",
    difficulty: "Expert",
    missionType: "create_wrapped",
    targetFruit: "wrapped",
    targetEmoji: "🎁",
    targetCount: 4,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 5,
    obstacles: { type: "volcanic", fire_geyser: 10, lava_flow: 8 },
    bgColor: "from-red-950 via-orange-800 to-yellow-700",
    borderColor: "border-orange-600",
  },
  {
    id: 208,
    name: "Level 208",
    subtitle: "Sulfur Springs",
    difficulty: "Expert",
    missionType: "collect_fruit",
    targetFruit: "peach",
    targetEmoji: "🍑",
    targetCount: 60,
    moves: 28,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 5,
    obstacles: { type: "volcanic", ash_cloud: 12, magma_rock: 10 },
    bgColor: "from-yellow-800 via-orange-900 to-red-900",
    borderColor: "border-yellow-600",
  },
  {
    id: 209,
    name: "Level 209",
    subtitle: "Cinder Path",
    difficulty: "Expert",
    missionType: "create_wrapped",
    targetFruit: "wrapped",
    targetEmoji: "🎁",
    targetCount: 5,
    moves: 35,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 5,
    obstacles: { type: "volcanic", lava_flow: 12, fire_geyser: 6 },
    bgColor: "from-gray-800 via-red-800 to-orange-700",
    borderColor: "border-gray-600",
  },
  {
    id: 210,
    name: "Level 210",
    subtitle: "PHOENIX KING",
    difficulty: "BOSS",
    missionType: "boss_fight",
    levelType: "boss_fight",
    targetFruit: "phoenix",
    targetEmoji: "🦅",
    targetCount: 1,
    moves: 999,
    boardSize: 9,
    freeRetry: true,
    boss: {
      name: "Phoenix King",
      type: "phoenix",
      phases: [
        { hp: 8000, weakSpot: "apple", weakEmoji: "🍎", attack: "flame_wave", attackName: "Flame Wave" }
      ],
      attackInterval: 4,
      baseDamage: 18,
      weakSpotMultiplier: 2.0,
      comboMultiplier: 1.8,
    },
    rewards: { stars: 350, xp: 18000, frame: "phoenix_slayer", frameName: "Phoenix Slayer" },
    obstacles: { type: "volcanic", fire_geyser: 6, magma_rock: 4 },
    bgColor: "from-red-600 via-orange-500 to-yellow-400",
    borderColor: "border-red-500",
  },
  // Levels 211-219: Harder volcanic levels
  {
    id: 211,
    name: "Level 211",
    subtitle: "Inferno Pit",
    difficulty: "Expert",
    missionType: "collect_fruit",
    targetFruit: "grape",
    targetEmoji: "🍇",
    targetCount: 65,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 4,
    obstacles: { type: "volcanic", lava_flow: 15, magma_rock: 10, fire_geyser: 5 },
    bgColor: "from-red-950 via-red-800 to-orange-700",
    borderColor: "border-red-700",
  },
  {
    id: 212,
    name: "Level 212",
    subtitle: "Pyroclastic Flow",
    difficulty: "Expert",
    missionType: "reach_score",
    targetFruit: "score",
    targetEmoji: "⭐",
    targetCount: 16000,
    moves: 38,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 4,
    obstacles: { type: "volcanic", ash_cloud: 18, fire_geyser: 8 },
    bgColor: "from-gray-900 via-orange-900 to-red-800",
    borderColor: "border-orange-700",
  },
  {
    id: 213,
    name: "Level 213",
    subtitle: "Caldera Lake",
    difficulty: "Legendary",
    missionType: "collect_fruit",
    targetFruit: "pineapple",
    targetEmoji: "🍍",
    targetCount: 70,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 4,
    obstacles: { type: "volcanic", lava_flow: 18, magma_rock: 12 },
    bgColor: "from-blue-900 via-red-800 to-orange-700",
    borderColor: "border-blue-700",
  },
  {
    id: 214,
    name: "Level 214",
    subtitle: "Volcanic Vents",
    difficulty: "Legendary",
    missionType: "reach_score",
    targetFruit: "banana",
    targetEmoji: "⭐",
    targetCount: 15000,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 3,
    obstacles: { type: "volcanic", fire_geyser: 15, ash_cloud: 10 },
    bgColor: "from-yellow-700 via-orange-800 to-red-900",
    borderColor: "border-yellow-600",
  },
  {
    id: 215,
    name: "Level 215",
    subtitle: "Magma Fortress",
    difficulty: "Legendary",
    missionType: "combo_mission",
    targetFruit: "combo",
    targetEmoji: "💥",
    targetCount: 12,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 3,
    obstacles: { type: "volcanic", magma_rock: 20, lava_flow: 15, stone: 8 },
    bgColor: "from-red-950 via-orange-900 to-yellow-800",
    borderColor: "border-red-600",
  },
  {
    id: 216,
    name: "Level 216",
    subtitle: "Ember Storm",
    difficulty: "Legendary",
    missionType: "collect_fruit",
    targetFruit: "cherry",
    targetEmoji: "🍒",
    targetCount: 75,
    moves: 30,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 3,
    obstacles: { type: "volcanic", ash_cloud: 20, fire_geyser: 12, magma_rock: 8 },
    bgColor: "from-orange-900 via-red-900 to-gray-900",
    borderColor: "border-orange-600",
  },
  {
    id: 217,
    name: "Level 217",
    subtitle: "Lava Falls",
    difficulty: "Legendary",
    missionType: "collect_fruit",
    targetFruit: "cherry",
    targetEmoji: "🍒",
    targetCount: 80,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 3,
    obstacles: { type: "volcanic", lava_flow: 22, fire_geyser: 10 },
    bgColor: "from-red-800 via-orange-700 to-yellow-600",
    borderColor: "border-red-500",
  },
  {
    id: 218,
    name: "Level 218",
    subtitle: "Core Approach",
    difficulty: "Master",
    missionType: "create_striped",
    targetFruit: "striped",
    targetEmoji: "🌈",
    targetCount: 8,
    moves: 32,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 3,
    obstacles: { type: "volcanic", magma_rock: 18, ash_cloud: 15, lava_flow: 12 },
    bgColor: "from-red-950 via-red-800 to-orange-700",
    borderColor: "border-red-800",
  },
  {
    id: 219,
    name: "Level 219",
    subtitle: "Final Descent",
    difficulty: "Master",
    missionType: "reach_score",
    targetFruit: "banana",
    targetEmoji: "⭐",
    targetCount: 16000,
    moves: 38,
    boardSize: 10,
    worldMechanic: "lava_rise",
    lavaRiseRate: 2,
    obstacles: { type: "volcanic", lava_flow: 25, fire_geyser: 15, magma_rock: 12 },
    bgColor: "from-black via-red-950 to-orange-900",
    borderColor: "border-gray-800",
  },
  {
    id: 220,
    name: "Level 220",
    subtitle: "PHOENIX REBIRTH",
    difficulty: "BOSS",
    missionType: "boss_fight",
    levelType: "boss_fight",
    targetFruit: "phoenix",
    targetEmoji: "🔥",
    targetCount: 1,
    moves: 999,
    boardSize: 9,
    freeRetry: true,
    boss: {
      name: "Phoenix Reborn",
      type: "phoenix_final",
      phases: [
        { hp: 12000, weakSpot: "orange", weakEmoji: "🍊", attack: "rebirth_flame", attackName: "Rebirth Flame" }
      ],
      attackInterval: 3,
      baseDamage: 22,
      weakSpotMultiplier: 2.2,
      comboMultiplier: 2.0,
    },
    rewards: { stars: 500, xp: 25000, frame: "phoenix_master", frameName: "Phoenix Master" },
    obstacles: { type: "volcanic", fire_geyser: 10, lava_flow: 8, magma_rock: 6 },
    bgColor: "from-yellow-500 via-orange-500 to-red-600",
    borderColor: "border-yellow-400",
  },
];

// ===== MOONLIGHT GARDEN (221-240) =====
// Theme: Mystical night garden with day/night cycle
// Unique Mechanic: Every 3 moves switches lighting, some fruits only match during day/night
export const MOONLIGHT_GARDEN_LEVELS = [
  {
    id: 221,
    name: "Level 221",
    subtitle: "Twilight Entrance",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "grape",
    targetEmoji: "🍇",
    targetCount: 45,
    moves: 30,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 4,
    obstacles: { type: "moonlight", moonflower: 8, shadow_vine: 5 },
    bgColor: "from-indigo-900 via-purple-800 to-pink-700",
    borderColor: "border-indigo-500",
  },
  {
    id: 222,
    name: "Level 222",
    subtitle: "Firefly Glade",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "apple",
    targetEmoji: "🍎",
    targetCount: 50,
    moves: 28,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 4,
    obstacles: { type: "moonlight", firefly_swarm: 10, moonflower: 6 },
    bgColor: "from-blue-900 via-indigo-800 to-purple-700",
    borderColor: "border-blue-500",
  },
  {
    id: 223,
    name: "Level 223",
    subtitle: "Shadow Grove",
    difficulty: "Hard",
    missionType: "create_wrapped",
    targetFruit: "wrapped",
    targetEmoji: "🎁",
    targetCount: 4,
    moves: 30,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 3,
    obstacles: { type: "moonlight", shadow_vine: 12, sunbloom: 8 },
    bgColor: "from-gray-900 via-purple-900 to-indigo-800",
    borderColor: "border-gray-600",
  },
  {
    id: 224,
    name: "Level 224",
    subtitle: "Dawn's Light",
    difficulty: "Hard",
    missionType: "collect_fruit",
    targetFruit: "pear",
    targetEmoji: "🍐",
    targetCount: 55,
    moves: 30,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 3,
    obstacles: { type: "moonlight", sunbloom: 12, firefly_swarm: 6 },
    bgColor: "from-orange-600 via-pink-600 to-purple-700",
    borderColor: "border-orange-400",
  },
  {
    id: 225,
    name: "Level 225",
    subtitle: "Lunar Path",
    difficulty: "Expert",
    missionType: "reach_score",
    targetFruit: "banana",
    targetEmoji: "⭐",
    targetCount: 12000,
    moves: 32,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 3,
    obstacles: { type: "moonlight", moonflower: 15, shadow_vine: 10 },
    bgColor: "from-slate-900 via-indigo-900 to-blue-800",
    borderColor: "border-slate-600",
  },
  {
    id: 226,
    name: "Level 226",
    subtitle: "Starlit Pond",
    difficulty: "Expert",
    missionType: "collect_fruit",
    targetFruit: "peach",
    targetEmoji: "🍑",
    targetCount: 60,
    moves: 30,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 3,
    obstacles: { type: "moonlight", firefly_swarm: 12, moonflower: 10, sunbloom: 8 },
    bgColor: "from-blue-950 via-purple-900 to-pink-800",
    borderColor: "border-blue-600",
  },
  {
    id: 227,
    name: "Level 227",
    subtitle: "Eclipse Garden",
    difficulty: "Expert",
    missionType: "collect_fruit",
    targetFruit: "grape",
    targetEmoji: "🍇",
    targetCount: 60,
    moves: 28,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", shadow_vine: 15, sunbloom: 12 },
    bgColor: "from-black via-purple-950 to-indigo-900",
    borderColor: "border-purple-700",
  },
  {
    id: 228,
    name: "Level 228",
    subtitle: "Midnight Bloom",
    difficulty: "Expert",
    missionType: "collect_fruit",
    targetFruit: "cherry",
    targetEmoji: "🍒",
    targetCount: 65,
    moves: 30,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", moonflower: 18, firefly_swarm: 10 },
    bgColor: "from-indigo-950 via-purple-900 to-pink-700",
    borderColor: "border-indigo-600",
  },
  {
    id: 229,
    name: "Level 229",
    subtitle: "Solar Flare",
    difficulty: "Legendary",
    missionType: "combo_mission",
    targetFruit: "combo",
    targetEmoji: "💥",
    targetCount: 10,
    moves: 28,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", sunbloom: 18, shadow_vine: 12, firefly_swarm: 8 },
    bgColor: "from-yellow-600 via-orange-600 to-red-700",
    borderColor: "border-yellow-500",
  },
  {
    id: 230,
    name: "Level 230",
    subtitle: "DREAM WEAVER",
    difficulty: "BOSS",
    missionType: "boss_fight",
    levelType: "boss_fight",
    targetFruit: "dream",
    targetEmoji: "💫",
    targetCount: 1,
    moves: 999,
    boardSize: 9,
    freeRetry: true,
    boss: {
      name: "Dream Weaver",
      type: "dream_weaver",
      phases: [
        { hp: 9000, weakSpot: "grape", weakEmoji: "🍇", attack: "illusion_mist", attackName: "Illusion Mist" }
      ],
      attackInterval: 4,
      baseDamage: 18,
      weakSpotMultiplier: 2.0,
      comboMultiplier: 1.9,
    },
    rewards: { stars: 400, xp: 20000, frame: "dream_catcher", frameName: "Dream Catcher" },
    obstacles: { type: "moonlight", moonflower: 8, shadow_vine: 6 },
    bgColor: "from-purple-600 via-indigo-600 to-blue-700",
    borderColor: "border-purple-400",
  },
  // Continue levels 231-240...
  {
    id: 231,
    name: "Level 231",
    subtitle: "Waking Dreams",
    difficulty: "Legendary",
    missionType: "collect_fruit",
    targetFruit: "orange",
    targetEmoji: "🍊",
    targetCount: 70,
    moves: 32,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", moonflower: 20, sunbloom: 15, shadow_vine: 10 },
    bgColor: "from-indigo-900 via-purple-800 to-pink-600",
    borderColor: "border-indigo-500",
  },
  {
    id: 232,
    name: "Level 232",
    subtitle: "Phantom Petals",
    difficulty: "Legendary",
    missionType: "create_striped",
    targetFruit: "striped",
    targetEmoji: "🌈",
    targetCount: 7,
    moves: 32,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", firefly_swarm: 15, moonflower: 12 },
    bgColor: "from-pink-900 via-purple-800 to-indigo-900",
    borderColor: "border-pink-500",
  },
  {
    id: 233,
    name: "Level 233",
    subtitle: "Celestial Dance",
    difficulty: "Legendary",
    missionType: "reach_score",
    targetFruit: "banana",
    targetEmoji: "⭐",
    targetCount: 15000,
    moves: 35,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", sunbloom: 18, shadow_vine: 15 },
    bgColor: "from-blue-900 via-indigo-800 to-violet-700",
    borderColor: "border-blue-500",
  },
  {
    id: 234,
    name: "Level 234",
    subtitle: "Aurora Veil",
    difficulty: "Master",
    missionType: "create_striped",
    targetFruit: "striped",
    targetEmoji: "🌈",
    targetCount: 8,
    moves: 35,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", moonflower: 15, firefly_swarm: 12, sunbloom: 10 },
    bgColor: "from-green-700 via-blue-700 to-purple-700",
    borderColor: "border-green-500",
  },
  {
    id: 235,
    name: "Level 235",
    subtitle: "Twilight Maze",
    difficulty: "Master",
    missionType: "collect_fruit",
    targetFruit: "pineapple",
    targetEmoji: "🍍",
    targetCount: 75,
    moves: 32,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", shadow_vine: 20, moonflower: 15, stone: 6 },
    bgColor: "from-purple-950 via-indigo-900 to-blue-800",
    borderColor: "border-purple-600",
  },
  {
    id: 236,
    name: "Level 236",
    subtitle: "Solstice Peak",
    difficulty: "Master",
    missionType: "create_wrapped",
    targetFruit: "wrapped",
    targetEmoji: "🎁",
    targetCount: 5,
    moves: 35,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", sunbloom: 20, firefly_swarm: 15 },
    bgColor: "from-orange-700 via-pink-700 to-purple-800",
    borderColor: "border-orange-500",
  },
  {
    id: 237,
    name: "Level 237",
    subtitle: "Equinox Balance",
    difficulty: "Master",
    missionType: "combo_mission",
    targetFruit: "combo",
    targetEmoji: "💥",
    targetCount: 15,
    moves: 30,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", moonflower: 18, sunbloom: 18, shadow_vine: 12 },
    bgColor: "from-yellow-600 via-green-600 to-blue-700",
    borderColor: "border-yellow-400",
  },
  {
    id: 238,
    name: "Level 238",
    subtitle: "Night's End",
    difficulty: "Master",
    missionType: "collect_fruit",
    targetFruit: "grape",
    targetEmoji: "🍇",
    targetCount: 80,
    moves: 32,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", firefly_swarm: 20, shadow_vine: 18, moonflower: 12 },
    bgColor: "from-indigo-950 via-purple-950 to-black",
    borderColor: "border-indigo-700",
  },
  {
    id: 239,
    name: "Level 239",
    subtitle: "Dawn Awakening",
    difficulty: "Master",
    missionType: "reach_score",
    targetFruit: "banana",
    targetEmoji: "⭐",
    targetCount: 18000,
    moves: 38,
    boardSize: 10,
    worldMechanic: "day_night",
    cycleLength: 2,
    obstacles: { type: "moonlight", sunbloom: 22, moonflower: 18, firefly_swarm: 10 },
    bgColor: "from-pink-600 via-orange-500 to-yellow-500",
    borderColor: "border-pink-400",
  },
  {
    id: 240,
    name: "Level 240",
    subtitle: "ETERNAL TWILIGHT",
    difficulty: "BOSS",
    missionType: "boss_fight",
    levelType: "boss_fight",
    targetFruit: "moon",
    targetEmoji: "🌙",
    targetCount: 1,
    moves: 999,
    boardSize: 9,
    freeRetry: true,
    boss: {
      name: "Twilight Guardian",
      type: "twilight",
      phases: [
        { hp: 13000, weakSpot: "cherry", weakEmoji: "🍒", attack: "eternal_night", attackName: "Eternal Night" }
      ],
      attackInterval: 3,
      baseDamage: 24,
      weakSpotMultiplier: 2.2,
      comboMultiplier: 2.0,
    },
    rewards: { stars: 550, xp: 28000, frame: "twilight_master", frameName: "Twilight Master" },
    obstacles: { type: "moonlight", moonflower: 10, sunbloom: 10, shadow_vine: 8 },
    bgColor: "from-purple-500 via-pink-500 to-orange-500",
    borderColor: "border-purple-300",
  },
];

// Export all new levels combined
export const NEW_WORLD_LEVELS = [
  ...VOLCANIC_CORE_LEVELS,
  ...MOONLIGHT_GARDEN_LEVELS,
];

// Generate remaining worlds with similar patterns
export const generateRemainingLevels = () => {
  const levels = [];
  
  // Alchemist's Lab (241-260)
  for (let i = 241; i <= 260; i++) {
    const isBoss = i === 250 || i === 260;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 250 ? "MAD ALCHEMIST" : "GRAND TRANSMUTATION") : `Potion ${i - 240}`,
      difficulty: isBoss ? "BOSS" : (i < 250 ? "Hard" : "Expert"),
      missionType: isBoss ? "boss_fight" : ["collect_fruit", "create_striped", "reach_score", "create_wrapped"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "alchemist" : ["apple", "grape", "orange", "pear", "peach"][Math.floor(Math.random() * 5)],
      targetEmoji: isBoss ? "⚗️" : ["🍎", "🍇", "🍊", "🍐", "🍑"][Math.floor(Math.random() * 5)],
      targetCount: isBoss ? 1 : 45 + Math.floor((i - 241) * 2),
      moves: isBoss ? 999 : 28 + Math.floor(Math.random() * 6),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 250 ? "Mad Alchemist" : "Grand Transmuter",
        type: i === 250 ? "alchemist" : "transmuter",
        phases: [{ hp: i === 250 ? 10000 : 15000, weakSpot: "grape", weakEmoji: "🍇", attack: "toxic_brew", attackName: "Toxic Brew" }],
        attackInterval: 4,
        baseDamage: 20,
        weakSpotMultiplier: 2.0,
        comboMultiplier: 1.9,
      } : undefined,
      rewards: isBoss ? { stars: i === 250 ? 450 : 600, xp: i === 250 ? 22000 : 30000, frame: "alchemist_master", frameName: "Alchemist Master" } : undefined,
      worldMechanic: "potion_mixing",
      obstacles: { type: "alchemy", potion_bubble: 8 + Math.floor((i - 241) / 2), cauldron: 4, toxic_spill: 3 + Math.floor((i - 241) / 4) },
      bgColor: "from-emerald-900 via-green-800 to-lime-700",
      borderColor: "border-emerald-500",
    });
  }
  
  // Circus Carnival (261-280)
  for (let i = 261; i <= 280; i++) {
    const isBoss = i === 270 || i === 280;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 270 ? "RINGMASTER" : "GRAND FINALE") : `Act ${i - 260}`,
      difficulty: isBoss ? "BOSS" : (i < 270 ? "Hard" : "Expert"),
      missionType: isBoss ? "boss_fight" : ["collect_fruit", "create_wrapped", "combo_mission", "reach_score"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "ringmaster" : ["cherry", "banana", "apple", "pear"][Math.floor(Math.random() * 4)],
      targetEmoji: isBoss ? "🎪" : ["🍒", "🍌", "🍎", "🍐"][Math.floor(Math.random() * 4)],
      targetCount: isBoss ? 1 : 50 + Math.floor((i - 261) * 2),
      moves: isBoss ? 999 : 26 + Math.floor(Math.random() * 6),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 270 ? "The Ringmaster" : "Circus King",
        type: i === 270 ? "ringmaster" : "circus_king",
        phases: [{ hp: i === 270 ? 11000 : 16000, weakSpot: "cherry", weakEmoji: "🍒", attack: "juggle_bombs", attackName: "Juggle Bombs" }],
        attackInterval: 4,
        baseDamage: 22,
        weakSpotMultiplier: 2.0,
        comboMultiplier: 1.9,
      } : undefined,
      rewards: isBoss ? { stars: i === 270 ? 500 : 650, xp: i === 270 ? 24000 : 32000, frame: "circus_master", frameName: "Circus Master" } : undefined,
      worldMechanic: "spinning_board",
      obstacles: { type: "circus", spinning_wheel: 6 + Math.floor((i - 261) / 3), balloon: 8, confetti_cannon: 4 },
      bgColor: "from-pink-600 via-purple-500 to-blue-500",
      borderColor: "border-pink-400",
    });
  }
  
  // Pirate Shipwreck (281-300)
  for (let i = 281; i <= 300; i++) {
    const isBoss = i === 290 || i === 300;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 290 ? "CAPTAIN BLACKFIN" : "KRAKEN'S REVENGE") : `Deck ${i - 280}`,
      difficulty: isBoss ? "BOSS" : (i < 290 ? "Expert" : "Legendary"),
      missionType: isBoss ? "boss_fight" : ["collect_fruit", "create_wrapped", "break_ice", "reach_score"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "pirate" : ["orange", "grape", "apple", "pineapple"][Math.floor(Math.random() * 4)],
      targetEmoji: isBoss ? "🏴‍☠️" : ["🍊", "🍇", "🍎", "🍍"][Math.floor(Math.random() * 4)],
      targetCount: isBoss ? 1 : 55 + Math.floor((i - 281) * 2),
      moves: isBoss ? 999 : 28 + Math.floor(Math.random() * 5),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 290 ? "Captain Blackfin" : "Kraken's Wrath",
        type: i === 290 ? "blackfin" : "kraken_wrath",
        phases: [{ hp: i === 290 ? 12000 : 18000, weakSpot: "orange", weakEmoji: "🍊", attack: "cannon_barrage", attackName: "Cannon Barrage" }],
        attackInterval: 4,
        baseDamage: 24,
        weakSpotMultiplier: 2.1,
        comboMultiplier: 2.0,
      } : undefined,
      rewards: isBoss ? { stars: i === 290 ? 550 : 700, xp: i === 290 ? 26000 : 35000, frame: "pirate_legend", frameName: "Pirate Legend" } : undefined,
      worldMechanic: "rising_water",
      waterRiseRate: 6 - Math.floor((i - 281) / 5),
      obstacles: { type: "pirate", water_level: 5, treasure_chest: 6, ghost_pirate: 4 + Math.floor((i - 281) / 4), barnacle: 8 },
      bgColor: "from-slate-800 via-blue-900 to-cyan-800",
      borderColor: "border-slate-500",
    });
  }
  
  // Cherry Blossom Temple (301-320)
  for (let i = 301; i <= 320; i++) {
    const isBoss = i === 310 || i === 320;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 310 ? "TEMPLE GUARDIAN" : "ZEN MASTER") : `Harmony ${i - 300}`,
      difficulty: isBoss ? "BOSS" : (i < 310 ? "Expert" : "Legendary"),
      missionType: isBoss ? "boss_fight" : ["collect_fruit", "combo_mission", "reach_score", "create_wrapped"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "temple" : ["peach", "cherry", "apple", "pear"][Math.floor(Math.random() * 4)],
      targetEmoji: isBoss ? "🌸" : ["🍑", "🍒", "🍎", "🍐"][Math.floor(Math.random() * 4)],
      targetCount: isBoss ? 1 : 55 + Math.floor((i - 301) * 2),
      moves: isBoss ? 999 : 28 + Math.floor(Math.random() * 5),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 310 ? "Temple Guardian" : "Zen Master",
        type: i === 310 ? "temple_guardian" : "zen_master",
        phases: [{ hp: i === 310 ? 13000 : 19000, weakSpot: "peach", weakEmoji: "🍑", attack: "cherry_storm", attackName: "Cherry Storm" }],
        attackInterval: 4,
        baseDamage: 22,
        weakSpotMultiplier: 2.1,
        comboMultiplier: 2.0,
      } : undefined,
      rewards: isBoss ? { stars: i === 310 ? 600 : 750, xp: i === 310 ? 28000 : 38000, frame: "zen_warrior", frameName: "Zen Warrior" } : undefined,
      worldMechanic: "harmony_bonus",
      obstacles: { type: "temple", harmony_stone: 8, wind_chime: 6, koinobori: 4 + Math.floor((i - 301) / 3), zen_rock: 5 },
      bgColor: "from-pink-300 via-pink-400 to-rose-500",
      borderColor: "border-pink-200",
    });
  }
  
  // Storm Kingdom (321-340)
  for (let i = 321; i <= 340; i++) {
    const isBoss = i === 330 || i === 340;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 330 ? "THUNDER LORD" : "STORM KING") : `Storm ${i - 320}`,
      difficulty: isBoss ? "BOSS" : (i < 330 ? "Legendary" : "Master"),
      missionType: isBoss ? "boss_fight" : ["collect_fruit", "create_striped", "combo_mission", "reach_score"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "storm" : ["grape", "apple", "banana", "orange"][Math.floor(Math.random() * 4)],
      targetEmoji: isBoss ? "⚡" : ["🍇", "🍎", "🍌", "🍊"][Math.floor(Math.random() * 4)],
      targetCount: isBoss ? 1 : 60 + Math.floor((i - 321) * 2),
      moves: isBoss ? 999 : 26 + Math.floor(Math.random() * 5),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 330 ? "Thunder Lord" : "Storm King",
        type: i === 330 ? "thunder_lord" : "storm_king",
        phases: [{ hp: i === 330 ? 14000 : 20000, weakSpot: "grape", weakEmoji: "🍇", attack: "lightning_storm", attackName: "Lightning Storm" }],
        attackInterval: 3,
        baseDamage: 26,
        weakSpotMultiplier: 2.2,
        comboMultiplier: 2.1,
      } : undefined,
      rewards: isBoss ? { stars: i === 330 ? 650 : 800, xp: i === 330 ? 30000 : 40000, frame: "storm_conqueror", frameName: "Storm Conqueror" } : undefined,
      worldMechanic: "lightning_strikes",
      obstacles: { type: "storm", lightning_rod: 6, storm_cloud: 8 + Math.floor((i - 321) / 3), thunder_orb: 5, wind_gust: 6 },
      bgColor: "from-gray-800 via-purple-800 to-yellow-600",
      borderColor: "border-yellow-400",
    });
  }
  
  // Mushroom Cavern (341-360)
  for (let i = 341; i <= 360; i++) {
    const isBoss = i === 350 || i === 360;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 350 ? "SPORE LORD" : "FUNGAL KING") : `Spore ${i - 340}`,
      difficulty: isBoss ? "BOSS" : (i < 350 ? "Legendary" : "Master"),
      missionType: isBoss ? "boss_fight" : ["collect_fruit", "clear_chocolate", "reach_score", "create_wrapped"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "mushroom" : ["grape", "cherry", "pear", "apple"][Math.floor(Math.random() * 4)],
      targetEmoji: isBoss ? "🍄" : ["🍇", "🍒", "🍐", "🍎"][Math.floor(Math.random() * 4)],
      targetCount: isBoss ? 1 : 60 + Math.floor((i - 341) * 2),
      moves: isBoss ? 999 : 28 + Math.floor(Math.random() * 5),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 350 ? "Spore Lord" : "Fungal King",
        type: i === 350 ? "spore_lord" : "fungal_king",
        phases: [{ hp: i === 350 ? 15000 : 22000, weakSpot: "cherry", weakEmoji: "🍒", attack: "spore_cloud", attackName: "Spore Cloud" }],
        attackInterval: 3,
        baseDamage: 26,
        weakSpotMultiplier: 2.2,
        comboMultiplier: 2.1,
      } : undefined,
      rewards: isBoss ? { stars: i === 350 ? 700 : 850, xp: i === 350 ? 32000 : 42000, frame: "spore_master", frameName: "Spore Master" } : undefined,
      worldMechanic: "spore_spread",
      obstacles: { type: "mushroom", spore_mushroom: 10 + Math.floor((i - 341) / 2), glowing_fungus: 6, poison_cap: 5, mycelium: 8 },
      bgColor: "from-purple-900 via-violet-800 to-fuchsia-700",
      borderColor: "border-purple-500",
    });
  }
  
  // Casino Royale (361-380)
  for (let i = 361; i <= 380; i++) {
    const isBoss = i === 370 || i === 380;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 370 ? "DEALER" : "JACKPOT KING") : `Bet ${i - 360}`,
      difficulty: isBoss ? "BOSS" : (i < 370 ? "Master" : "Master"),
      missionType: isBoss ? "boss_fight" : ["reach_score", "collect_fruit", "combo_mission", "create_wrapped"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "casino" : ["cherry", "grape", "orange", "apple"][Math.floor(Math.random() * 4)],
      targetEmoji: isBoss ? "🎰" : ["🍒", "🍇", "🍊", "🍎"][Math.floor(Math.random() * 4)],
      targetCount: isBoss ? 1 : 65 + Math.floor((i - 361) * 2),
      moves: isBoss ? 999 : 26 + Math.floor(Math.random() * 5),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 370 ? "The Dealer" : "Jackpot King",
        type: i === 370 ? "dealer" : "jackpot_king",
        phases: [{ hp: i === 370 ? 16000 : 24000, weakSpot: "cherry", weakEmoji: "🍒", attack: "wild_cards", attackName: "Wild Cards" }],
        attackInterval: 3,
        baseDamage: 28,
        weakSpotMultiplier: 2.3,
        comboMultiplier: 2.2,
      } : undefined,
      rewards: isBoss ? { stars: i === 370 ? 750 : 900, xp: i === 370 ? 35000 : 45000, frame: "high_roller", frameName: "High Roller" } : undefined,
      worldMechanic: "random_multipliers",
      obstacles: { type: "casino", slot_machine: 6, dice_block: 8 + Math.floor((i - 361) / 3), card_deck: 5, jackpot_tile: 4 },
      bgColor: "from-amber-600 via-yellow-500 to-red-600",
      borderColor: "border-amber-400",
    });
  }
  
  // Cosmic Nebula (381-400) - FINAL WORLD
  for (let i = 381; i <= 400; i++) {
    const isBoss = i === 390 || i === 400;
    levels.push({
      id: i,
      name: `Level ${i}`,
      subtitle: isBoss ? (i === 390 ? "VOID WALKER" : "CELESTIAL DRAGON") : `Nebula ${i - 380}`,
      difficulty: isBoss ? "BOSS" : "Master",
      missionType: isBoss ? "boss_fight" : ["collect_fruit", "combo_mission", "reach_score", "create_wrapped"][Math.floor(Math.random() * 4)],
      levelType: isBoss ? "boss_fight" : undefined,
      targetFruit: isBoss ? "cosmic" : ["grape", "apple", "cherry", "orange", "pear"][Math.floor(Math.random() * 5)],
      targetEmoji: isBoss ? "🌌" : ["🍇", "🍎", "🍒", "🍊", "🍐"][Math.floor(Math.random() * 5)],
      targetCount: isBoss ? 1 : 70 + Math.floor((i - 381) * 2),
      moves: isBoss ? 999 : 28 + Math.floor(Math.random() * 4),
      boardSize: isBoss ? 9 : 10,
      freeRetry: isBoss ? true : undefined,
      boss: isBoss ? {
        name: i === 390 ? "Void Walker" : "Celestial Dragon",
        type: i === 390 ? "void_walker" : "celestial_dragon",
        phases: [{ hp: i === 390 ? 18000 : 30000, weakSpot: "grape", weakEmoji: "🍇", attack: i === 390 ? "void_rift" : "cosmic_annihilation", attackName: i === 390 ? "Void Rift" : "Cosmic Annihilation" }],
        attackInterval: 3,
        baseDamage: i === 390 ? 30 : 35,
        weakSpotMultiplier: 2.5,
        comboMultiplier: 2.5,
      } : undefined,
      rewards: isBoss ? { stars: i === 390 ? 800 : 1000, xp: i === 390 ? 40000 : 50000, frame: i === 390 ? "void_master" : "cosmic_champion", frameName: i === 390 ? "Void Master" : "Cosmic Champion" } : undefined,
      worldMechanic: "gravity_shift",
      gravityDirection: ["down", "up", "left", "right"][Math.floor(Math.random() * 4)],
      obstacles: { type: "cosmic", black_hole: 4 + Math.floor((i - 381) / 4), gravity_well: 6, star_dust: 10, wormhole: 5 + Math.floor((i - 381) / 3) },
      bgColor: "from-violet-950 via-purple-900 to-indigo-800",
      borderColor: "border-violet-500",
    });
  }
  
  return levels;
};

// ===== MEMBERSHIP EXCLUSIVE WORLDS =====
// Note: Membership levels are imported from memberWorld.js and vipWorld.js
// Crystal Paradise Levels (9001-9050) - from memberWorld.js
// Royal Citadel Levels (8001-8050) - from vipWorld.js

// Get all new levels including membership worlds
export const ALL_NEW_LEVELS = [
  ...NEW_WORLD_LEVELS,
  ...generateRemainingLevels(),
  ...VIP_WORLD_LEVELS,     // 8001-8050 (Royal Citadel)
  ...MEMBER_WORLD_LEVELS,  // 9001-9050 (Crystal Paradise)
];
